import * as React from 'react';
import type { IListPageLayoutExtrasProps } from './list-page-layout.types';
import { cn } from '@utils';

export const ListPageLayoutExtras = React.forwardRef<HTMLDivElement, IListPageLayoutExtrasProps>(
	({ className, children, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex items-center gap-2', className)}
			data-testid="list-page-layout-extras"
			{...props}
		>
			{children}
		</div>
	)
);
ListPageLayoutExtras.displayName = 'ListPageLayoutExtras';
